import { render, staticRenderFns } from "./core_waybill_related_columns.vue?vue&type=template&id=16d01b2e&scoped=true&"
import script from "./core_waybill_related_columns.vue?vue&type=script&lang=js&"
export * from "./core_waybill_related_columns.vue?vue&type=script&lang=js&"
import style0 from "./core_waybill_related_columns.vue?vue&type=style&index=0&id=16d01b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d01b2e",
  null
  
)

export default component.exports